import { useSyncExternalStore } from "react";

/** Phones and narrow windows: panels become drawers and sheets (matches app.css). */
export const NARROW_QUERY = "(max-width: 720px)";

export function matches(query: string): boolean {
  return globalThis.matchMedia?.(query).matches ?? false;
}

/** Whether a media query matches, kept up to date. */
export function useMedia(query: string): boolean {
  return useSyncExternalStore(
    (listener) => {
      const list = globalThis.matchMedia?.(query);
      list?.addEventListener("change", listener);
      return () => list?.removeEventListener("change", listener);
    },
    () => matches(query),
  );
}
